/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A reason for an Employee to be on leave
 * @export
 * @interface LeaveType
 */
export interface LeaveType {
    /**
     * 
     * @type {number}
     * @memberof LeaveType
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveType
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveType
     */
    deductionLeaveTypeId: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveType
     */
    isSystemType: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaveType
     */
    name: string;
    /**
     * The status of the entity.
     * @type {string}
     * @memberof LeaveType
     */
    status: LeaveTypeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaveType
     */
    colour: string;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveType
     */
    paid: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaveType
     */
    payCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeaveType
     */
    displayIcon: LeaveTypeDisplayIconEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaveType
     */
    leaveAllowanceType: LeaveTypeLeaveAllowanceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaveType
     */
    leaveAllowanceUnit: LeaveTypeLeaveAllowanceUnitEnum;
    /**
     * Leave entitlement for this leave type when using the 'Fixed' allowance type.
     * @type {number}
     * @memberof LeaveType
     */
    leaveAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaveType
     */
    accrualRatePerHour: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaveType
     */
    accrualLimitDaysPerPeriod: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveType
     */
    accrualAllowedOnOvertimeHours: boolean;
}

/**
* @export
* @enum {string}
*/
export enum LeaveTypeStatusEnum {
    Active = 'Active',
    Archived = 'Archived',
    Deleted = 'Deleted'
}
/**
* @export
* @enum {string}
*/
export enum LeaveTypeDisplayIconEnum {
    Baby = 'fa-solid fa-baby',
    BabyCarriage = 'fa-solid fa-baby-carriage',
    BasketShoppingSimple = 'fa-solid fa-basket-shopping-simple',
    Bed = 'fa-solid fa-bed',
    Briefcase = 'fa-solid fa-briefcase',
    CakeCandles = 'fa-solid fa-cake-candles',
    Car = 'fa-solid fa-car',
    CarBus = 'fa-solid fa-car-bus',
    Clock = 'fa-solid fa-clock',
    EarthEurope = 'fa-solid fa-earth-europe',
    FaceFrownSlight = 'fa-solid fa-face-frown-slight',
    FaceThermometer = 'fa-solid fa-face-thermometer',
    Gavel = 'fa-solid fa-gavel',
    Gift = 'fa-solid fa-gift',
    GraduationCap = 'fa-solid fa-graduation-cap',
    HandsPraying = 'fa-solid fa-hands-praying',
    HandHoldingHeart = 'fa-solid fa-hand-holding-heart',
    HeadSideGear = 'fa-solid fa-head-side-gear',
    House = 'fa-solid fa-house',
    Paw = 'fa-solid fa-paw',
    PersonBreastfeeding = 'fa-solid fa-person-breastfeeding',
    PersonPregnant = 'fa-solid fa-person-pregnant',
    Plane = 'fa-solid fa-plane',
    Snowflake = 'fa-solid fa-snowflake',
    Spa = 'fa-solid fa-spa',
    SquarePlus = 'fa-solid fa-square-plus',
    SuitcaseRolling = 'fa-solid fa-suitcase-rolling',
    UmbrellaBeach = 'fa-solid fa-umbrella-beach',
    Users = 'fa-solid fa-users',
    Virus = 'fa-solid fa-virus'
}
/**
* @export
* @enum {string}
*/
export enum LeaveTypeLeaveAllowanceTypeEnum {
    Accrued = 'Accrued',
    DeductsFromAnother = 'Deducts From Another',
    Fixed = 'Fixed',
    Unlimited = 'Unlimited'
}
/**
* @export
* @enum {string}
*/
export enum LeaveTypeLeaveAllowanceUnitEnum {
    Days = 'Days',
    Hours = 'Hours'
}


/**
 * Check if a given object implements the LeaveType interface.
 */
export function instanceOfLeaveType(value: object): value is LeaveType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('deductionLeaveTypeId' in value) || value['deductionLeaveTypeId'] === undefined) return false;
    if (!('isSystemType' in value) || value['isSystemType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('colour' in value) || value['colour'] === undefined) return false;
    if (!('paid' in value) || value['paid'] === undefined) return false;
    if (!('payCode' in value) || value['payCode'] === undefined) return false;
    if (!('displayIcon' in value) || value['displayIcon'] === undefined) return false;
    if (!('leaveAllowanceType' in value) || value['leaveAllowanceType'] === undefined) return false;
    if (!('leaveAllowanceUnit' in value) || value['leaveAllowanceUnit'] === undefined) return false;
    if (!('leaveAllowance' in value) || value['leaveAllowance'] === undefined) return false;
    if (!('accrualRatePerHour' in value) || value['accrualRatePerHour'] === undefined) return false;
    if (!('accrualLimitDaysPerPeriod' in value) || value['accrualLimitDaysPerPeriod'] === undefined) return false;
    if (!('accrualAllowedOnOvertimeHours' in value) || value['accrualAllowedOnOvertimeHours'] === undefined) return false;
    return true;
}

export function LeaveTypeFromJSON(json: any): LeaveType {
    return LeaveTypeFromJSONTyped(json, false);
}

export function LeaveTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'deductionLeaveTypeId': json['deductionLeaveTypeId'],
        'isSystemType': json['isSystemType'],
        'name': json['name'],
        'status': json['status'],
        'colour': json['colour'],
        'paid': json['paid'],
        'payCode': json['payCode'],
        'displayIcon': json['displayIcon'],
        'leaveAllowanceType': json['leaveAllowanceType'],
        'leaveAllowanceUnit': json['leaveAllowanceUnit'],
        'leaveAllowance': json['leaveAllowance'],
        'accrualRatePerHour': json['accrualRatePerHour'],
        'accrualLimitDaysPerPeriod': json['accrualLimitDaysPerPeriod'],
        'accrualAllowedOnOvertimeHours': json['accrualAllowedOnOvertimeHours'],
    };
}

  export function LeaveTypeToJSON(json: any): LeaveType {
      return LeaveTypeToJSONTyped(json, false);
  }

  export function LeaveTypeToJSONTyped(value?: LeaveType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'deductionLeaveTypeId': value['deductionLeaveTypeId'],
        'isSystemType': value['isSystemType'],
        'name': value['name'],
        'status': value['status'],
        'colour': value['colour'],
        'paid': value['paid'],
        'payCode': value['payCode'],
        'displayIcon': value['displayIcon'],
        'leaveAllowanceType': value['leaveAllowanceType'],
        'leaveAllowanceUnit': value['leaveAllowanceUnit'],
        'leaveAllowance': value['leaveAllowance'],
        'accrualRatePerHour': value['accrualRatePerHour'],
        'accrualLimitDaysPerPeriod': value['accrualLimitDaysPerPeriod'],
        'accrualAllowedOnOvertimeHours': value['accrualAllowedOnOvertimeHours'],
    };
}

